module.exports = __webpack_public_path__ + "static/img/icon_add_2.74a1740a.png";